// extracted by mini-css-extract-plugin
export default {"container":"NN-z","topReviewHeading":"ON-z","criticalReview":"PN-z","favorableReview":"QN-z","vsSeparator":"RN-z"};